import { useEffect, useState } from "react";

const MINIMIZED_KEY = "minimizedWidgets";

export const useMinimizedWidgets = () => {
  const [minimized, setMinimized] = useState<string[]>([]);

  useEffect(() => {
    const saved = localStorage.getItem(MINIMIZED_KEY);
    if (saved) {
      setMinimized(JSON.parse(saved));
    }
  }, []);

  const updateStorage = (list: string[]) => {
    localStorage.setItem(MINIMIZED_KEY, JSON.stringify(list));
    setMinimized(list);
  };

  const toggleWidget = (widgetID: string) => {
    setMinimized((prevMinimized) => {
      const newMinimized = new Set(prevMinimized);
      if (newMinimized.has(widgetID)) {
        newMinimized.delete(widgetID); // Remove from minimized
      } else {
        newMinimized.add(widgetID); // Add to minimized
      }
      return [...newMinimized]; // Return new array reference
    });
  };

  const setMinimizedState = (widgetID: string, shouldMinimize: boolean) => {
    setMinimized((prev) => {
      const alreadyMinimized = prev.includes(widgetID);
      let newList = prev;

      if (shouldMinimize && !alreadyMinimized) {
        newList = [...prev, widgetID];
      } else if (!shouldMinimize && alreadyMinimized) {
        newList = prev.filter((id) => id !== widgetID);
      }

      updateStorage(newList);
      return newList;
    });
  };

  return { minimized, toggleWidget, setMinimizedState };
};
